import SectionHeader from "components/Common/SectionHeader"
import React from "react"
import { Card, CardBody } from "reactstrap"
import StockPricingUpdate from "./StockPricingUpdate"
import { formatBDT } from "utils/formatPrice"
import ThemePlaceholder from "components/Common/ThemePlaceholder"

export default function Pricing({ stock, loading = false }) {
  const renderValue = value =>
    loading ? (
      <ThemePlaceholder style={{ width: 80, height: 20, borderRadius: 4 }} />
    ) : (
      value
    )

  const youSave =
    stock?.asking_price && stock?.discount_price
      ? stock.asking_price - stock.discount_price
      : 0

  const youSavePercent =
    stock?.asking_price && stock?.discount_price
      ? Math.round(((stock.asking_price - stock.discount_price) / stock.asking_price) * 100)
      : 0

  return (
    <Card className="border-0 shadow-sm">
      <CardBody className="p-3">
        <SectionHeader
          icon="bx bx-dollar"
          title="Pricing Information"
          action={loading ? null : <StockPricingUpdate stock={stock} />}
        />
        <div className="d-flex justify-content-between align-items-center mb-2">
          <span className="text-muted">Asking Price:</span>
          <span className="fw-medium">{renderValue(formatBDT(stock?.asking_price) || "-")}</span>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <span className="text-muted">Discount Price:</span>
          <span className="fw-medium text-primary">{renderValue(formatBDT(stock?.discount_price) || "-")}</span>
        </div>
        {stock?.asking_price > stock?.discount_price && (
          <div className="d-flex justify-content-between align-items-center">
            <span className="text-muted">You Save:</span>
            <span className="fw-medium text-success">
              {renderValue(
                `${formatBDT(youSave)} (${youSavePercent}%)`
              )}
            </span>
          </div>
        )}
      </CardBody>
    </Card>
  )
}
